import { css } from '@emotion/react';
import { createTheme } from '@mui/material/styles';

// css var
const headerHeight = 52;
const footerHeight = 40;

const mainHeight = css`
  height: calc(100vh - ${headerHeight}px - ${footerHeight}px);
`;

const themeOptions = createTheme({
  typography: {
    fontFamily: ['Poppins', '-apple-system', 'BlinkMacSystemFont', 'sans-serif'].join(',')
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-input': {
            height: '38px',
            boxSizing: 'border-box'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            display: 'none'
          }
          // '&.Mui-focused': {
          //   '& .MuiOutlinedInput-notchedOutline': {
          //     border: '1px solid #2e4cc2'
          //   }
          // }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        text: {
          color: '#000'
        }
        // contained: {
        //   backgroundColor: '#2e4cc2',
        //   color: '#FFFFFF',
        //   '&.MuiButton-contained': {
        //     backgroundColor: '#2e4cc2'
        //   }
        // },
        // outlined: {
        //   border: '1px solid #2e4cc2',
        //   backgroundColor: '#FFFFFF',
        //   color: '#2e4cc2',
        //   '&.MuiButton-outlined': {
        //     backgroundColor: '#FFFFFF'
        //   }
        // }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'inherit',
          '&.Mui-checked': {
            // color: '#2e4cc2'
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          width: '100%',
          height: '40px'
        },
        inputRoot: {
          padding: 0,
          paddingLeft: '2px',
          paddingRight: '26px'
        }
      }
    }
  },
  palette: {
    fontColor: {
      main: '#2f2f35'
    },
    white: {
      main: '#ffffff',
      disable: '#ffffff'
    },
    gray: {
      light: '#f8f8f8',
      main: '#D9D9D9',
      dark: '#585959',
      default: '#ADADAD',
      border: '#DADADA'
    },
    green: {
      light: '#F2EBD9',
      main: '#de3e47',
      login: '#de3e47',
      dark: '#8B7443'
    },
    success: {
      main: '#27704D'
    },
    alert: {
      main: '#FFC16E'
    },
    error: {
      main: '#DE3E47'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 360,
      md: 600,
      lg: 1024,
      xl: 1440
    }
  }
});

export { headerHeight, footerHeight, themeOptions, mainHeight };
